'use client'

import { Card, CardContent } from '@/components/card'
import { Textarea } from '@/components/textarea'
import { Button } from '@/components/ui/common/Button'
import { cn } from '@/utils/common'
import * as React from 'react'

interface OpenQuestionCardProps {
  title: string
  placeholder?: string
  maxLength?: number
  value?: string
  onChange?: (value: string) => void
  onNext?: () => void
  className?: string
}

export function OpenQuestionCard({
  title,
  placeholder = 'Wpisz swoją odpowiedź tutaj...',
  maxLength = 500,
  value = '',
  onChange,
  onNext,
  className
}: OpenQuestionCardProps) {
  const [text, setText] = React.useState(value)
  const characterCount = text.length

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = e.target.value
    if (maxLength && newValue.length > maxLength) return
    setText(newValue)
    onChange?.(newValue)
  }

  React.useEffect(() => {
    setText(value || '')
  }, [value])

  return (
    <Card className={cn('w-full', className)}>
      <CardContent className="pt-6">
        <div className="space-y-4">
          <h3 className="text-center text-base font-medium">{title}</h3>
          <div className="relative">
            <Textarea
              placeholder={placeholder}
              value={text}
              onChange={handleChange}
              className="min-h-[120px] resize-none"
            />
            <div className="absolute right-2 bottom-2 text-xs text-gray-500">
              {characterCount}/{maxLength} znaków
            </div>
          </div>
          <div className="text-center">
            <Button 
            className='bg-[#2bcaca], hover:bg-[#2b9999]'
            onClick={onNext}>Dalej</Button>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
